import type { ActionRegistryEntry } from './template/MasterDocumentTemplate.types';

/**
 * Resultado de evaluar el soporte declarativo de "acción deshabilitada con
 * motivo" para una entrada del `actionRegistry`.
 */
export interface ActionDisabledState {
  /** true cuando el `docState` actual está incluido en `entry.disabledStates`. */
  disabled: boolean;
  /** Tooltip (atributo `title`) a mostrar cuando `disabled` es true. */
  disabledReason?: string;
}

/**
 * Evalúa si una acción debe mostrarse VISIBLE pero DESHABILITADA en el estado
 * actual del documento.
 *
 * Una acción cuyo `disabledStates` incluye el `docState` actual se renderiza
 * deshabilitada (en vez de oculta), mostrando `disabledTooltip` como tooltip.
 * Acciones sin `disabledStates` devuelven `{ disabled: false }`, es decir, se
 * comportan exactamente como antes (retrocompatibilidad total).
 *
 * @see ActionRegistryEntry.disabledStates
 * @see ActionRegistryEntry.disabledTooltip
 */
export function resolveActionDisabledState(
  entry: Pick<ActionRegistryEntry, 'disabledStates' | 'disabledTooltip'>,
  docState: string,
): ActionDisabledState {
  const disabled = entry.disabledStates?.includes(docState) ?? false;
  return {
    disabled,
    disabledReason: disabled ? entry.disabledTooltip : undefined,
  };
}
